import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AIhz9uVmVL6vBgUOYgAAAFAAAAA7AAAAQwAAAF0AAAA/AI138OJoV7qsBgUNQwAAAE8AAABGAAAAUQAAAE8AAABeK8UNzIcjCaoAAAAASUVORK5CYII="};
